import { MoreVert } from '@mui/icons-material'
import { Popover } from '@mui/material'
import { T, useTranslate } from '@tolgee/react'
import { useRef, useState } from 'react'
import { ListPosition, Microbutton } from 'ui'

export default function GalleryActions({
  setIsShowSelector,
  setSelectedGallery,
  selectedGallery,
  setModalData,
  setNewGalleryName,
  handleDeleteGallery,
}) {
  const { t } = useTranslate()
  const popoverRef = useRef()

  const [anchorEl, setAnchorEl] = useState(null)

  const handleOpenPopover = (event) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClosePopover = () => {
    setAnchorEl(null)
  }
  const isMainPopoverOpen = Boolean(anchorEl)
  const popoverId = isMainPopoverOpen ? 'templates' : undefined

  return (
    <div className='border-brand-form-accent sticky bottom-0 mt-auto flex h-[57px] gap-2 border-t bg-white p-2 sm:h-[73px] sm:gap-[10px] sm:p-4'>
      {!selectedGallery?.isMediaGallery && (
        <>
          <Microbutton
            variant='transparent-light'
            type='large-font'
            className='h-[40px] w-[40px] min-w-0 truncate uppercase'
            onClick={handleOpenPopover}
            data-tooltip-id='chatBotPanel-clear'
            icon={<MoreVert fontSize='inherit' />}
          />

          <Popover
            id={popoverId}
            open={isMainPopoverOpen}
            anchorEl={anchorEl}
            onClose={handleClosePopover}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
            transformOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
          >
            <div
              ref={popoverRef}
              className='bg-brand-accent-flat border-brand-form-accent space-y-[6px] rounded-[4px] border p-2 pb-[10px]'
            >
              {/* <ListPosition
            text={<T keyName='eleo-duplicate'>Duplicate</T>}
            className='sm:!mt-0'
            disabled={!selectedGallery?.id}
            onClick={() => {
              handleClosePopover()
              setNewGalleryName('')
              setModalData({
                isVisible: true,
                title: (
                  <T
                    keyName='eleo-gallery-duplicate-modal-title'
                    defaultValue='Duplicate <span>{name}</span>'
                    params={{
                      name: selectedGallery.name ?? t('eleo-default-gallery-name', 'Default'),
                      span: <span className='italic'></span>,
                    }}
                  />
                ),
                acceptLabel: t('eleo-duplicate', 'duplicate'),
                type: 'duplicate',
              })
            }}
          /> */}
              <ListPosition
                text={<T keyName='eleo-rename'>Rename</T>}
                disabled={
                  !selectedGallery?.value ||
                  !selectedGallery?.label ||
                  typeof selectedGallery.label === 'object'
                }
                onClick={() => {
                  handleClosePopover()
                  setNewGalleryName(selectedGallery.label ?? '')
                  setModalData({
                    isVisible: true,
                    title: (
                      <T
                        keyName='eleo-gallery-rename-modal-title'
                        defaultValue='Update gallery name'
                      />
                    ),
                    acceptLabel: t('eleo-rename', 'rename'),
                    type: 'rename',
                  })
                }}
              />

              <div className='border-brand-form-accent-light mx-[6px] my-[2px] border-b' />
              <ListPosition
                text={<T keyName='eleo-delete'>Delete</T>}
                disabled={
                  !selectedGallery?.value ||
                  !selectedGallery?.label ||
                  typeof selectedGallery.label === 'object'
                }
                onClick={() => {
                  handleClosePopover()

                  setModalData({
                    isVisible: true,
                    title: (
                      <T
                        keyName='eleo-gallery-delete-modal-title'
                        defaultValue='Delete <span>{name}</span>'
                        params={{
                          name: selectedGallery.label ?? t('eleo-default-gallery-name', 'Default'),
                          span: <span className='italic'></span>,
                        }}
                      />
                    ),
                    subtitle: (
                      <T keyName='eleo-your-story-delete-modal-subtitle'>
                        This action is irreversible
                      </T>
                    ),
                    acceptLabel: t('eleo-delete', 'delete'),
                    type: 'delete',
                  })
                }}
              />
            </div>
          </Popover>
        </>
      )}

      <Microbutton
        variant='transparent-light'
        type='main'
        className='block h-[40px] uppercase sm:hidden'
        onClick={() => {
          setSelectedGallery()
          setIsShowSelector(true)
        }}
        text={<T keyName='eleo-back'>back</T>}
      />
    </div>
  )
}
